module.exports = __webpack_public_path__ + "static/media/down-caret-white.ed50f02a.svg";